var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.99992C8.33337 10.4419 8.50897 10.8659 8.82153 11.1784C9.13409 11.491 9.55801 11.6666 10 11.6666C10.4421 11.6666 10.866 11.491 11.1786 11.1784C11.4911 10.8659 11.6667 10.4419 11.6667 9.99992C11.6667 9.55789 11.4911 9.13397 11.1786 8.82141C10.866 8.50885 10.4421 8.33325 10 8.33325C9.55801 8.33325 9.13409 8.50885 8.82153 8.82141C8.50897 9.13397 8.33337 9.55789 8.33337 9.99992ZM8.33337 4.99992C8.33337 5.44195 8.50897 5.86587 8.82153 6.17843C9.13409 6.49099 9.55801 6.66659 10 6.66659C10.4421 6.66659 10.866 6.49099 11.1786 6.17843C11.4911 5.86587 11.6667 5.44195 11.6667 4.99992C11.6667 4.55789 11.4911 4.13397 11.1786 3.82141C10.866 3.50885 10.4421 3.33325 10 3.33325C9.55801 3.33325 9.13409 3.50885 8.82153 3.82141C8.50897 4.13397 8.33337 4.55789 8.33337 4.99992ZM8.33337 14.9999C8.33337 15.4419 8.50897 15.8659 8.82153 16.1784C9.13409 16.491 9.55801 16.6666 10 16.6666C10.4421 16.6666 10.866 16.491 11.1786 16.1784C11.4911 15.8659 11.6667 15.4419 11.6667 14.9999C11.6667 14.5579 11.4911 14.134 11.1786 13.8214C10.866 13.5088 10.4421 13.3333 10 13.3333C9.55801 13.3333 9.13409 13.5088 8.82153 13.8214C8.50897 14.134 8.33337 14.5579 8.33337 14.9999Z",
    fill: "#2A2E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalOptions);
export default __webpack_public_path__ + "static/media/vertical-options.f1901c0b3102516d8bc7f67b263515e9.svg";
export { ForwardRef as ReactComponent };